<div class="container">
    <div class="heading-container">
        <mat-icon class="icon" (click)="goBack()">arrow_back</mat-icon>
    </div>
    <div class="profile-section">
        <div class="profile-top-section">
            <p class="profile-heading">Profile Details</p>
        </div>

        <div class="profile-bottom-section">
            <p class="profile-row-section">
                <span class="icon-section">
                    <mat-icon class="icon" fontSet="material-icons-outlined">person</mat-icon>
                </span>
                <span class="details-section">
                    <span class="name-label">Full Name</span>
                    <span class="name-value">{{ userDetails?.user?.name }}</span>
                </span>
            </p>
            <p class="profile-row-section">
                <span class="icon-section">
                    <mat-icon class="icon" fontSet="material-icons-outlined">phone</mat-icon>
                </span>
                <span class="details-section">
                    <span class="mobile-label">Mobile Number</span>
                    <span class="mobile-value">{{ userDetails?.user?.userMobileNumber }}</span>
                </span>
            </p>

            <p class="profile-row-section">
                <span class="icon-section">
                    <mat-icon class="icon" fontSet="material-icons-outlined">email</mat-icon>
                </span>
                <span class="details-section">
                    <span class="email-label">Email Id</span>
                    <span class="email-value">{{ userDetails?.user?.email }}</span>
                </span>
            </p>

            <p class="profile-row-section">
                <span class="icon-section">
                    <mat-icon class="icon" fontSet="material-icons-outlined">calendar_today</mat-icon>
                </span>
                <span class="details-section">
                    <span class="age-label">Age</span>
                    <span class="age-value">{{ userDetails?.user?.age }} Years</span>
                </span>
            </p>
        </div>
    </div>
</div>
